import React, { useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import toastr from "../../utils/toast";
import { useOutletContext } from "react-router-dom";
import axios from "axios";
import {
  handleDeleteWithConfirm,
  contact_details,
} from "../../utils/sweetalert";

function ExecutivesModal({ onClose, id, seniority_level }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [seniority, setSeniority] = useState(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0, // MRT uses 0-based index
    pageSize: 50, // Match API pageLengt
  });
  const [executives, setExecutives] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [requestId, setRequestId] = useState("");
  const [executiveCounts, setExecutiveCounts] = useState({
    cs: null,
    vp: null,
    dir: null,
  });
  const { setGlobalLoading, token } = useOutletContext();

  const showexecutives = async () => {
    setPagination({ pageIndex: 0, pageSize: pagination.pageSize });
    setGlobalLoading(true);

    try {
      const rescount = await axios.post(
        `${API_BASE_URL}/lusha/get_executives_count`,
        { id: id, module: "companyinfo" },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setExecutiveCounts({
        cs: rescount.data?.cstotalResults || 0,
        vp: rescount.data?.vptotalResults || 0,
        dir: rescount.data?.dirtotalResults || 0,
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    console.log(id);
    showexecutives();
  }, [id]);

  useEffect(() => {
    setSeniority(seniority_level);
  }, [seniority_level]);

  useEffect(() => {
    if (!seniority) return;
    fetchData();
  }, [seniority, pagination.pageIndex, pagination.pageSize]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/lusha/get_executives/`,
        {
          id: id,
          seniority: seniority,
          page: pagination.pageIndex,
          size: pagination.pageSize,
          module: "companyinfo",
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (response.status == 200) {
        if (response.data.result.length == 0) {
          toastr.error("No executives found");
          onClose?.(1);
        }
        setRequestId(response.data.requestId);
        setExecutives(response.data.result);
        console.log(response.data.requestId);
        console.log(response.data.result);
        setRowCount(response.data.totalResults);
      } else if (response.status == 500) {
        toastr.error("Please Try Again");
      }
    } catch (error) {
      // 💬 API responded with an error (e.g. 400, 404, 500)
      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.error ||
          "Please Wait a few seconds and try again.";

        if (status === 400) {
          toastr.warning("Missing or invalid parameters");
        } else if (status === 404) {
          toastr.warning("Company domain not found");
        } else if (status === 504) {
          toastr.warning("Third-party API took too long, please retry");
        } else {
          toastr.error(message);
        }

        console.error("API Error:", status, message);
      }
      // 🚫 No response from server (e.g., backend down, CORS issue)
      else if (error.request) {
        toastr.error("No response from server. Check your network connection.");
        console.error(
          "Network request made but no response received:",
          error.request,
        );
      }
      // 💥 Axios setup or other errors
      else {
        toastr.error("Request setup failed: " + error.message);
        console.error("Axios error:", error.message);
      }
    } finally {
      setGlobalLoading(false);
      setLoading(false);
    }
  };

  const excolumns = [
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "jobTitle",
      header: "Designation",
    },
    {
      accessorKey: "contactId",
      header: "Action",
      Cell: ({ row }) => {
        return (
          <ul className="contact-icon d-flex align-items-center ">
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  fetchExContact("revealEmails", row.original.contactId);
                }}
                title="Reveal Email"
                className="p-1 rounded-circle contact-icon-mail d-flex align-items-center justify-content-center"
              >
                <span className="d-flex align-items-center justify-content-center">
                  <i className="ti ti-mail text-gray-5"></i>
                </span>
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  fetchExContact("revealPhones", row.original.contactId);
                }}
                title="Reveal Phone"
                className="p-1 rounded-circle contact-icon-call d-flex align-items-center justify-content-center"
              >
                <span className="d-flex align-items-center justify-content-center">
                  <i className="ti ti-phone-call text-gray-5"></i>
                </span>
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  BuildRelation(row.original.contactId);
                }}
                title="Add To Contact"
                className="p-1 rounded-circle contact-icon-msg d-flex align-items-center justify-content-center"
              >
                <span className="d-flex align-items-center justify-content-center">
                  <i className="fa-regular fa-handshake text-gray-5"></i>
                </span>
              </a>
            </li>
          </ul>
        );
      },
    },
  ];

  const fetchExContact = async (para, contactId) => {
    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/lusha/fetch_contact_details`,
        {
          requestId: requestId,
          contactIds: contactId,
          parameter: para,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      console.log(response);
      const data = response.data?.lushares;
      if (data) {
        const emails =
          data?.emailAddresses.map((item) => item.email).join(", ") || "";
        const phone =
          response.data?.lushares.phoneNumbers
            .map((item) => item.number)
            .join(", ") || "";
        if (para === "revealEmails" && emails != "") {
          contact_details({
            title: "Emails",
            text: emails,
            icon: "info",
            confirmButtonText: "Copy To ClipBoard",
            confirmCallback: () => CopyDetails(emails),
          });
        } else if (para === "revealPhones" && phone != "") {
          contact_details({
            title: "Phone Numbers",
            text: phone,
            icon: "info",
            confirmButtonText: "Copy To ClipBoard",
            confirmCallback: () => CopyDetails(phone),
          });
        } else {
          contact_details({
            title: "Opps!",
            text: "No Data Found",
            icon: "error",
            confirmButtonText: "Okay",
          });
        }
      } else {
        contact_details({
          title: "Opps!",
          text: "No Data Found",
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
    } catch (error) {
      console.log(error);
      toastr.error(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const CopyDetails = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toastr.success("Copied to clipboard");
    } catch (error) {
      console.log(error);
      toastr.error(error);
    }
  };

  const BuildRelation = async (contactId) => {
    try {
      setGlobalLoading(true);
      // Step 1: enrich + create/find candidate (client-agnostic — no clientId)
      const enrichResponse = await axios.post(
        `${API_BASE_URL}/lusha/prospecting_contact_enrich`,
        {
          requestId: requestId,
          contactIds: contactId,
          parameter: "revealEmails",
          companyinfo_id: id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      const candidate_id = enrichResponse.data.candidate_id;

      // Step 2: sync into companyinfo_contacts (and build_relations, if a client exists)
      const syncResponse = await axios.post(
        `${API_BASE_URL}/lusha/add_companyinfo_contact`,
        {
          companyinfo_id: id,
          candidate_id: candidate_id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      toastr.success(syncResponse.data.message);
    } catch (error) {
      console.log(error.response);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };
  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Executives</h5>
              <button
                type="button"
                onClick={onClose}
                className="btn-close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-1">
                <button
                  type="button"
                  className={`btn btn-outline-primary rounded-pill ms-1 ${
                    seniority == 9 ? "active" : ""
                  }`}
                  onClick={() => {
                    setSeniority(9);
                  }}
                >
                  C-Suite - {executiveCounts.cs ? executiveCounts.cs : 0}
                </button>
                <button
                  type="button"
                  className={`btn btn-outline-secondary rounded-pill ms-1 ${
                    seniority == 8 ? "active" : ""
                  }`}
                  onClick={() => {
                    setSeniority(8);
                  }}
                >
                  VPs - {executiveCounts.vp ? executiveCounts.vp : 0}
                </button>
                <button
                  type="button"
                  className={`btn btn-outline-warning rounded-pill ms-1 ${
                    seniority == 6 ? "active" : ""
                  }`}
                  onClick={() => {
                    setSeniority(6);
                  }}
                >
                  Directors - {executiveCounts.dir ? executiveCounts.dir : 0}
                </button>
              </div>
              <MaterialReactTable
                columns={excolumns}
                data={executives}
                rowCount={rowCount}
                manualPagination
                onPaginationChange={setPagination}
                state={{ pagination, isLoading: loading }}
                enablePagination
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExecutivesModal;
